import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IconModule } from 'src/app/components/icon/icon.module';
import { FormFieldModule } from 'src/app/components/form-field/form-field.module';
import { DialogModule } from 'src/app/components/dialog/dialog.module';
import { SelectModule } from 'src/app/components/select/select.module';
import { RouterModule } from '@angular/router';

import { ContainerHeaderModule } from 'src/app/components/container-header';
import { DynamicTableModule } from 'src/app/components/dynamic-table';
import { StatusBadgeModule } from 'src/app/components/status-badge/status-badge.module';

import { BucketResolver } from './bucket.resolver';
import { BucketFacade } from './bucket.facade';
import { BucketComponent } from './bucket.component';
import { ButtonModule } from 'src/app/components/button/button.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IconModule,
    FormFieldModule,
    ButtonModule,
    DialogModule,
    SelectModule,
    RouterModule,

    ContainerHeaderModule,
    DynamicTableModule,
    StatusBadgeModule,
  ],
  providers: [BucketResolver, BucketFacade],
  declarations: [BucketComponent],
  exports: [BucketComponent],
})
export class BucketModule {}
